import { createSlice } from '@reduxjs/toolkit';


const initialState = {
	inCall: false,
	isPinned: false
};

const roomSlice = createSlice({
	name: 'room',
	initialState,
	reducers: {
        enterCall: (set) => {set({inCall: true})},
        leaveCall: (set) => {set({inCall: false})},
		setIsPinned: (state, action) => {
			state.isPinned = action.payload;
		},
		togglePinned: (state, action) => {
			state.isPinned = !state.isPinned;
		},
	},
	extraReducers: {
	},
});

export default roomSlice.reducer;

export const { enterCall, leaveCall, togglePinned, setIsPinned } = roomSlice.actions;
